/**
 * 大会設定画面のUI定数
 */

export const TOURNAMENT_SETUP_LAYOUT = {
  titleY: 80,
  subtitleY: 130,
  buttonStartY: 200,
  buttonSpacing: 60,
  charButtonStartY: 200,
  charButtonSpacing: 50,
  charColumns: 4,
  charColumnWidth: 200,
  difficultyStartY: 200,
  backButtonY: 480,
} as const;

export const TOURNAMENT_SETUP_LABELS = {
  title: '大会モード',
  selectType: '大会方式を選んでください',
  roundRobin: '総当たり戦',
  roundRobinDesc: '全員と1回ずつ対戦し、勝ち点で順位を決める',
  elimination: 'トーナメント戦',
  eliminationDesc: '負けたら即敗退。勝ち上がりで優勝を目指す',
  selectCharacter: 'キャラクターを選んでください',
  selectDifficulty: 'CPU難易度を選んでください',
  back: '戻る',
} as const;
